<plan-clases-alumnos 
    [planClaseRoute]="planClaseRoute" 
    [evaluacionTipo]="evaluacionTipo"
    [verificarFechaInicial]="verificarFechaInicial"
></plan-clases-alumnos>